import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getTransactionEntriesNUmber } from "../../store/slices/TransactionsSlice";
import CustomTable from "../../components/Shared/CustomTable";
import { useTranslation } from "react-i18next";
import PageHeader from "../../components/Shared/PageHeader";

const EntryDetailsPage = () => {
  const { journalNumber } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const { accStatementEntries } = useSelector((state) => state.transaction);

  useEffect(() => {
    if (journalNumber) {
      dispatch(getTransactionEntriesNUmber(journalNumber));
    }
  }, [dispatch, journalNumber]);

  const viewTansationColumns = [
    {
      field: lang === "en" ? `account_name_en` : `account_name_ar`,
      header: t("AccountName"),
    },
    {
      field: "account_code",
      header: t("Account Code"),
    },
    {
      field: lang === "en" ? `cost_center_name_en` : `cost_center_name_ar`,
      header: t("costCenter"),
    },
    {
      header: t("Branch"),
      body: (data) => {
        return lang === "en"
          ? data?.branch_name_en || data?.location_name_en || ""
          : data?.branch_name_ar || data?.location_name_ar || "";
      },
    },
    {
      field: "description",
      header: t("description"),
    },
    {
      field: "amount",
      header: t("debitAmount"),
      body: (rowData) =>
        rowData?.entry_type.toLowerCase() === "debit"
          ? `${rowData?.amount} SAR`
          : "0 SAR",
    },
    {
      field: "payment_method",
      header: t("creditAmount"),
      body: (rowData) =>
        rowData?.entry_type.toLowerCase() === "credit"
          ? `${rowData?.amount} SAR`
          : "0 SAR",
    },
    {
      field: "amount",
      header: t("Balance"),
      body: (rowData) => {
        const amount = Number(rowData?.amount) || 0;
        const isDebit = rowData?.entry_type?.toLowerCase() === "debit";
        const displayAmount = isDebit
          ? `+${amount.toFixed(2)}`
          : `-${amount.toFixed(2)}`;
        return `${displayAmount} SAR`;
      },
    },
  ];

  return (
    <div className="flex rounded-md w-full gap-2 flex-col icon_hover">
      <PageHeader
        title={t("Entries")}
        onBack={() =>
          navigate("/manager/report", { state: { activeTabIndex: 3 } })
        }
      />
      <div className="h-full overflow-y-auto">
        <CustomTable
          data={accStatementEntries}
          columns={viewTansationColumns}
        />
      </div>
    </div>
  );
};

export default EntryDetailsPage;
